import { render, staticRenderFns } from "./KhoanNoForm.vue?vue&type=template&id=2c559fc0&"
import script from "./KhoanNoForm.vue?vue&type=script&lang=js&"
export * from "./KhoanNoForm.vue?vue&type=script&lang=js&"
import style0 from "./KhoanNoForm.vue?vue&type=style&index=0&id=2c559fc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports